import PropTypes from 'prop-types';
import './primitives.css';

/**
 * PageContainer
 *
 * Single source of truth for page-level padding, max-width, and vertical
 * rhythm. Replaces the ad-hoc `style={{ padding: isMobile ? 8 : 24 }}` blocks
 * that were duplicated across every feature page.
 *
 * Variants:
 *   - `bleed`  : full-bleed (no horizontal padding) – used by tables/chat
 *   - `narrow` : narrow column for forms / read-heavy content
 *   - default  : comfortable, capped at --layout-content-max-width
 */
const PageContainer = ({ children, variant = 'default', className = '', style }) => {
  const variantClass =
    variant === 'bleed'
      ? 'lms-page-container--bleed'
      : variant === 'narrow'
        ? 'lms-page-container--narrow'
        : '';

  return (
    <div className={`lms-page-container ${variantClass} ${className}`.trim()} style={style}>
      {children}
    </div>
  );
};

PageContainer.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf(['default', 'bleed', 'narrow']),
  className: PropTypes.string,
  style: PropTypes.object,
};

export default PageContainer;
